import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as StackTrace from 'stacktrace-js';
import { EventAggregatorService } from './event-aggregator.service';
import { Platform } from '@ionic/angular/lazy';
import { ENV } from '../app.config';
import { tryConvertToJsonString } from '../shared/try-convert-to-json-string.function';
import { Device } from '@capacitor/device';
import { LogErrorForm } from '@smartmoving/sm-shared-lib';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private lastErrorMessage: string;

  constructor(
      private readonly injector: Injector,
      private readonly httpClient: HttpClient,
      private readonly platform: Platform
  ) {
  }

  async handleError(error) {

    console.log('Handling error', tryConvertToJsonString(error));

    let errorString = '';
    if (error.toString) {
      errorString = error.toString();
    }

    if (!errorString || errorString.indexOf('[object') > -1) {
      try {
        errorString = JSON.stringify(error);
      } catch {
        errorString = 'Unknown error - unable to stringify';
      }
    }

    if (errorString.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
      console.log('Handled ExpressionChangedAfterItHasBeenCheckedError error');
      return;
    }

    if (errorString.includes('"status":401')) {
      console.log('Handled 401 response error');
      return;
    }

    if (errorString.includes('Error: Loading chunk')) {
      const aggregator = this.injector.get(EventAggregatorService);
      aggregator.post('ChunkLoadFailed');
    }

    if (!(window as any).cordova) {
      console.log('Not running in Cordova!');
      throw error;
    }

    if (this.lastErrorMessage === errorString) {
      throw error;
    }
    this.lastErrorMessage = errorString;


    const location = this.injector.get(LocationStrategy);
    const message = error.message ? error.message : error.toString();
    const url = location instanceof PathLocationStrategy ? location.path() : '';

    let stackTrace;

    if (error.stack) {
      stackTrace = error.stack;
    } else {
      const frames = await StackTrace.fromError(error);

      stackTrace = frames
          .splice(0, 10)
          .map((sf) => sf.toString())
          .join('\n');
    }

    const form = new LogErrorForm();
    form.message = message;
    form.url = url;
    form.stackTrace = stackTrace;

    const deviceInfo = {
      device: {
        model: (await Device.getInfo()).model,
        platform: (await Device.getInfo()).platform,
        uuid: (await Device.getId()).identifier,
        version: (await Device.getInfo()).osVersion,
        manufacturer: (await Device.getInfo()).manufacturer,
        isVirtual: (await Device.getInfo()).isVirtual,
      },
      appVersion: ENV.version,
      screenRes: `${this.platform.width()} x ${this.platform.height()}`,

    };
    form.deviceInfo = JSON.stringify(deviceInfo);

    this.httpClient.post('logging/errors', form).subscribe(() => {
    }, err => {
      console.error('Something went wrong while pushing an error to the server.', err);
    });
  }
}
